/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import Youtube from "@components/Youtube";
import FloatingMenu from "../components/FloatingMenu";
import Header from "@img/Brand Lokal OK.png";

const LokalBrand = () => {
  const [datas, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(
        "https://cms.okoce.net/api/admin/local-brands"
      );
      if (!response.ok) {
        throw new Error("Gagal mengambil data brand lokal");
      }
      const data = await response.json();
      const brandData = data.data;
      setData(brandData);
    } catch (error) {
      // Jika terjadi kesalahan, pastikan untuk mengatur employees menjadi array kosong
      setData([]);
    }
  };

  return (
    <>
      <div className="mt-24 w-full h-auto grid justify-center content-center flex-col items-center">
        <div className="relative mx-auto w-full h-full">
          <img
            className="mobile:w-full mobile:h-full object-cover lg:mx-auto lg:w-full lg:h-auto"
            src={Header}
            alt=""
          />
          <div className="absolute left-1/2 transform -translate-x-1/2 flex flex-col items-center mobile:bottom-[-1] mobile:w-60 lg:w-80 lg:mb-4 lg:bottom-0 ">
            <a
              href=""
              className="bg-[#e01f31] hover:bg-red-700 rounded-lg text-white font-bold mobile:p-2 mobile:text-xs lg:text-lg lg:p-4"
            >
              PENDAFTARAN DI TUTUP
            </a>
          </div>
        </div>
      </div>
      <div className="flex max-w-6xl mx-auto justify-center m-12">
        <Youtube src="https://okoce.net/wp-content/uploads/2023/10/6.-HIGHRES-VIDEO-UCAPAN-BRAND-LOKAL-OK.mp4" />
      </div>
      <div className="mt-[6rem] bg-gray-300 w-full h-[22rem] grid justify-center content-center mobile:px-5">
        <h1 className="font-extrabold text-center mobile:text-2xl lg:text-4xl ">
          SELAMAT ATAS TERPILIHNYA 24 PRODUK UMKM
          <br />
          DARI 24 PENGGERAK YANG MENDAFTAR!
        </h1>
      </div>
      {/* <!-- component --> */}
      <div className="mt-[3rem] mb-[3rem] flex items-center justify-center">
        <div className="container w-4/5 mx-auto p-4">
          <div className="grid mobile:grid-cols-1 lg:grid-cols-2 gap-8">
            {/* <!-- Replace this with your grid items --> */}
            {datas.map((data, index) => (
              <div key={index} className="flex flex-col items-center">
                <img
                  loading="lazy"
                  src={`${process.env.REACT_APP_API_URL}/${data.image}`}
                  alt="Placeholder Image"
                  className="rounded-md object-cover mx-auto border lg:w-4/5 lg:h-96 "
                />
                <div className="px-1 py-4 text-center">
                  <div className="font-bold text-xl mb-2">{data.title}</div>
                  <div
                    className="text-gray-700 text-base"
                    dangerouslySetInnerHTML={{ __html: data.description }}
                  />
                </div>
              </div>
            ))}
            ;
          </div>
        </div>
      </div>
      <FloatingMenu />{" "}
    </>
  );
};

export default LokalBrand;
